import { render, staticRenderFns } from "./AddEventDialog.vue?vue&type=template&id=643dba47&"
import script from "./AddEventDialog.vue?vue&type=script&lang=js&"
export * from "./AddEventDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports